/**
 * Maps Denticon sandbox IDs to real Pearl IDs for demo environments.
 *
 * Ported from denticon-chrome-extension/app/denticon.js (lines 17-54).
 * Enabled only when the popup's "Sandbox Mode" toggle is on.
 */

export const OFFICE_MAP: Readonly<Record<string, string>> = {
  '145': '234',
  '155': '123',
};

export const PATIENT_MAP: Readonly<Record<string, string>> = {
  '5849': '183004448',
  '4738': '183004446',
  '5009': '10032500',
  '5581': '10063256',
  '5583': '183005073',
};

export interface SandboxIds {
  patientId: string | null;
  officeId: string | null;
}

/**
 * @param id - Office id from the page
 * @param sandboxEnabled - Popup sandbox toggle
 * @returns Remapped id when known, otherwise the original
 */
export function mapOfficeId(
  id: string | null,
  sandboxEnabled: boolean,
): string | null {
  if (id == null) return null;
  if (!sandboxEnabled) return id;
  return OFFICE_MAP[id] || id;
}

/**
 * @param id - Patient id from the page
 * @param sandboxEnabled - Popup sandbox toggle
 * @returns Remapped id when known, otherwise the original
 */
export function mapPatientId(
  id: string | null,
  sandboxEnabled: boolean,
): string | null {
  if (id == null) return null;
  if (!sandboxEnabled) return id;
  return PATIENT_MAP[id] || id;
}

/**
 * @param ids - Patient/office ids from the page
 * @param sandboxEnabled - Popup sandbox toggle
 * @returns Remapped ids when sandbox is on
 */
export function applySandboxMapping(
  ids: SandboxIds,
  sandboxEnabled: boolean,
): SandboxIds {
  return {
    patientId: mapPatientId(ids.patientId, sandboxEnabled),
    officeId: mapOfficeId(ids.officeId, sandboxEnabled),
  };
}
